// Sales review in the shared year-end workflow.
window.PlummeI18n.register('no', {
  'route.arsavslutning-salg': 'Salg',
  'clo.sales.title': 'Salg',
  'clo.sales.openReview': 'Se salgskontrollen',
  'clo.sales.year': 'Inntektsår {{year}}',
  'clo.sales.subtitle': 'Automatisk kontroll av utkast og mangler i salgsdokumenter for {{year}}.',
  'clo.sales.pending': 'Salgsdokumenter som må behandles før salgssteget for {{year}} er klart: {{count}}.',
  'clo.sales.ready': 'Dokumentkontrollen for {{year}} er fullført automatisk. Ingen utkast eller mangler funnet.',
  'clo.sales.followUp': 'Salgsdokumentene for {{year}} har bestått bokføringskontrollen. Utsendinger som bør følges opp: {{followUps}}.',
  'clo.sales.unsupported': 'Salgssteget er ikke støttet for dette landet, regelverket eller året.',
  'clo.sales.issuesTitle': 'Utkast og mangler',
  'clo.sales.noIssues': 'Ingen utkast eller mangelfulle salgsdokumenter i denne kontrollen.',
  'clo.sales.draft': 'Utkast må ferdigstilles eller fjernes hvis salget ikke skal gjennomføres.',
  'clo.sales.undated': 'Mangler gyldig dokumentdato. Avklar hvilket år salget tilhører.',
  'clo.sales.incomplete': 'Dokumentgrunnlaget er ufullstendig. Kontroller nummer, linjer og beskrivelse.',
  'clo.sales.unknownDate': 'År må avklares',
  'clo.sales.followUpsTitle': 'Følg opp utsending',
  'clo.sales.unsent': 'Ingen utsending registrert i Plumme',
  'clo.sales.deliveryFailed': 'Siste e-post kom ikke frem eller ble avvist',
  'clo.sales.sendingHelp': 'Kontroller at kunden har fått dokumentet. Utsending vises separat fra bokføring: dokumenter kan være levert utenfor Plumme, og e-poststatus dokumenterer ikke når inntekten er opptjent.',
  'clo.sales.receivablesTitle': 'Åpne kundeposter per 31.12.{{year}}',
  'clo.sales.receivablesHelp': 'Viser fakturaer og kreditnotaer i Plumme som stod åpne ved årsskiftet, også fra tidligere år. Senere betalinger endrer ikke beløpet per 31.12. Dette er ikke en full avstemming av konto 1500 eller importert historikk.',
  'clo.sales.settledAfter': 'Gjort opp etter årsskiftet: {{amount}}',
  'clo.sales.noReceivables': 'Ingen åpne kundeposter funnet i dette grunnlaget ved årsskiftet.',
  'clo.sales.otherSalesTitle': 'Andre bokførte salg',
  'clo.sales.invoiceListTitle': 'Fakturaliste',
  'clo.sales.approveWithoutChanges': 'Godkjenn uten endringer',
  'clo.sales.otherSale': 'Annet salg',
  'clo.sales.invoice': 'Faktura',
  'clo.sales.credit': 'Kreditnota',
  'clo.sales.openDocument': 'Åpne dokumentet',
  'clo.sales.openList': 'Åpne fakturalisten',
  'clo.sales.scopeHelp': 'Dokumentdato bestemmer hvilke salg som vises. Udaterte dokumenter må avklares; opprettelsesdato brukes ikke som salgsdato. Tilbud og ordrebekreftelser er ikke automatisk opptjent salg. Periodisering, manglende fakturering, tap, valuta og full avstemming vurderes i egne kontroller.',
  'clo.sales.back': 'Tilbake til salgskontrollen',
  'clo.sales.backToClosing': 'Tilbake til årsavslutning',
  'clo.sales.loadError': 'Kunne ikke åpne salgsflaten.',
  'clo.sales.documentGone': 'Dokumentet finnes ikke lenger i fakturalisten. Gå tilbake for oppdatert kontroll.',
});
